import axios from 'axios'

export const getFlights = async () => {
    const headers = {
        "Content-Type": "application/json",
        "x-auth-token": localStorage.getItem("x-auth-token"),
    }

    try {
        const url = "https://wayline.cvisqa.videri.ai/current-flight-task/" + localStorage.getItem("device_sn")
        const data = await axios.get(url, {headers})
        console.warn(data)
        return data.data.task
    } catch(e) {
        console.error(e)
        return null
    }
    
}